import React from 'react'

export default function Badge({bgColor = '#91d3ff',textColor = 'black', data}) {
  return (
    <p className="d-inline m-0 py-1 px-2 text-xs text-bold shadow" style={{backgroundColor: bgColor, borderRadius: "15px", color:textColor}}>
        {data}
    </p>
  )
}
